import { Component, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { distinctUntilChanged, debounceTime, skip } from 'rxjs/operators';

import { DefaultFilter } from './default-filter';

@Component({
    selector: 'select-filter',
    template: `
      <select [ngClass]="inputClass" class="form-control" [(ngModel)]="query" [formControl]="inputControl">
        <option value="">{{ column.getFilterConfig().selectText }}</option>
        @for (option of getList(); track option) {
          <option [value]="option.value">
            {{ option.title }}
          </option>
        }
      </select>
    `,
    standalone: false
})
export class SelectFilterComponent extends DefaultFilter implements OnInit {

  public inputControl: FormControl = new FormControl('');

  constructor() {
    super();
  }

  getList(): any[] {
    return this.column.getFilterConfig()?.list || [];
  }

  public ngOnInit() {
    if (this.inputControl && this.inputControl.valueChanges) {
      this.inputControl.valueChanges
        .pipe(
          skip(1),
          distinctUntilChanged(),
          debounceTime(this.delay)
        )
        .subscribe((value: string) => this.setFilter());
    }
  }
}
